import { c as _c } from "react/compiler-runtime";
import { Logger } from '@onefootprint/logger';
import { QueryClientProvider } from '@tanstack/react-query';
import type React from 'react';
import configureReactI18next from '@/config/initializers/react-i18next';
import queryClient from '@/config/initializers/react-query';
import CustomDesignSystemProvider from '../custom-design-system-provider';
import ErrorBoundary from '../error-boundary';

// No `deferSessionRecord`: the IDV apps defer RUM until a tenant is known, but the dashboard
// needs it from first paint to cover pre-login pages and firm employees. Only the replay
// recording is gated, in DatadogReplayProvider.
Logger.init('dashboard');
configureReactI18next();
const Providers = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <CustomDesignSystemProvider><QueryClientProvider client={queryClient}><ErrorBoundary>{children}</ErrorBoundary></QueryClientProvider></CustomDesignSystemProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default Providers;